import { useEffect, useState } from "react";

/** Height of the player header (`.upperaction` from the USER wrapper), kept in sync on resize. */
export default function useHeaderOffset() {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const measure = () => {
      const el = document.querySelector(".upperaction");
      setOffset(el ? Math.ceil(el.getBoundingClientRect().height) : 0);
    };
    measure();
    window.addEventListener("resize", measure);
    const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(measure) : null;
    const el = document.querySelector(".upperaction");
    if (ro && el) ro.observe(el);
    return () => {
      window.removeEventListener("resize", measure);
      ro?.disconnect();
    };
  }, []);
  return offset;
}

/**
 * On the board screens the header floats over the board art: give the logo a light backing so
 * it stays readable, and keep the page from scrolling behind the fixed board.
 */
export function useBoardPageBody() {
  useEffect(() => {
    document.body.classList.add("cr-board-page");
    return () => document.body.classList.remove("cr-board-page");
  }, []);
}

/** Start screen and How to Play: the same white backing behind the header logo, nothing else. */
export function useLogoBacking() {
  useEffect(() => {
    document.body.classList.add("cr-logo-backing");
    return () => document.body.classList.remove("cr-logo-backing");
  }, []);
}
